import { useEffect, useState } from "react";
// REDUX
import { useGetMessagesQuery } from "../../redux/messages/messagesAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { MessageInterface } from "../../interfaces/Message.interface";

export default function useGetAllMessages(
	{
		page = 1,
		limit = 999999,
		messageTypeId,
		deviceType,
	}: { page?: number; limit?: number; messageTypeId: string; deviceType: string } = {
		messageTypeId: "",
		deviceType: "",
	}
) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [messages, setMessages] = useState<MessageInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const buildSearchAndFilterString = () => {
		// Prevent undefined or empty values from being sent
		const validMessageTypeId = messageTypeId !== undefined && messageTypeId !== null && messageTypeId !== "" && messageTypeId !== "99999";
		const validDeviceType = deviceType !== undefined && deviceType !== null && deviceType !== "";

		if (!validMessageTypeId && !validDeviceType) {
			return "";
		}
		if (!validMessageTypeId && validDeviceType) {
			return `&filter_target=device_type&filter=${deviceType}`;
		}
		if (validMessageTypeId && !validDeviceType) {
			return `&filter_target=message_type_id&filter=${messageTypeId}`;
		}
		if (validMessageTypeId && validDeviceType) {
			return `&filter_target=message_type_id,%26device_type&filter=${messageTypeId},${deviceType}`;
		}
		return "";
	};

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetMessagesQuery(
		{ token, page, limit, searchAndFilterString: buildSearchAndFilterString() },
		{ skip: !token, refetchOnMountOrArgChange: false }
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setMessages(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		messages,
		isLoadingGetAllMessages: isLoading || isFetching,
		errorMessageGetAllMessages: errorMessage,
		isErrorGetAllMessages: isError,
		totalRowsGetAllMessages: data?.total ?? 0,
	};
}
